import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import './Button.css'

import IconCompactPlayer from '../svg/IconCompactPlayer';
import IconCompactPlayerActive from '../svg/IconCompactPlayerActive';

function ConnectedButtonCompactPlayer({ style, available = true }) {
  const [active, setActive] = useState(window.compact_mode_enable);
  const blank = () => {};
  const onClick = () => {
    setActive(!active);
    (window.compact_toggle) && window.compact_toggle();
    setTimeout(() => {
      const menu = document.getElementById('menu_vue_meter');
      if (menu && menu.classList.contains('bv_active')) {
        let vumaster = document.getElementById('vumaster');
        if (!vumaster) { vumaster = document.getElementById('master_vumeter'); }
        if (vumaster) { vumaster.style.opacity = 1; }
      }
    }, 20)
  }

  useEffect(() => {
    let vumaster = document.getElementById('vumaster');
    if (!vumaster) { vumaster = document.getElementById('master_vumeter'); }
    if (vumaster) {
      vumaster.style.opacity = (active) ? 0 : 1;

      const menuVolume = document.getElementById('menu_volume');
      if (menuVolume && menuVolume.classList.contains('bv_active')) {
        vumaster.style.opacity = 0;
      }
    }
    const master = document.querySelector('[id^="master"]');
    if (master) {
      master.style.opacity = (active) ? 0 : 1;
    }
  }, [active])

  return available ? (
    !active
    ? <IconCompactPlayer
      id={`menu_compact`} size={22} className={`topbutton button-compact-player ${!available && `no-available`}`}
      style={style}
      onClick={available ? onClick : blank} />
    : <IconCompactPlayerActive
      id={`menu_compact_active`} size={26} className={`topbutton button-compact-player-active ${!available && `no-available`}`}
      style={style}
      onClick={available ? onClick : blank} />
  ) : null
}

ConnectedButtonCompactPlayer.propTypes = {
  style: PropTypes.object
}

const ButtonCompactPlayer = connect(
  state => ({
    available: ( !state.inRoomPM || (state.inRoomPM && window.compact_mode_enable) )
  })
)(ConnectedButtonCompactPlayer);

export default ButtonCompactPlayer;
